import { motion } from 'framer-motion';

export function Testimonials() {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      company: 'Rodriguez Auto Group · Arlington, TX',
      text: 'Signarama Arlington transformed our entire fleet with stunning vehicle wraps. The quality is exceptional and our brand visibility has increased dramatically. Highly recommend — responsive team, premium results.',
      rating: 5,
      service: 'Vehicle Wraps',
    },
    {
      name: 'Sarah Thompson',
      company: 'Thompson Real Estate · Fort Worth, TX',
      text: 'From design to installation, the team was professional and creative. Our new storefront signage has attracted so many new clients. Best signage investment we\'ve made for the business.',
      rating: 5,
      service: 'Storefront Signs',
    },
    {
      name: 'David Chen',
      company: 'Chen Medical Center · Grand Prairie, TX',
      text: 'The wayfinding signage system they created is both beautiful and functional. Patients navigate easily, and the professional look enhances our entire brand image. Absolutely worth it.',
      rating: 5,
      service: 'Wayfinding System',
    },
    {
      name: 'Jennifer Martinez',
      company: 'Martinez Events & Catering · Mansfield, TX',
      text: 'We needed trade show displays on a tight deadline and Signarama delivered beyond expectations. Outstanding quality — we received countless compliments at the event.',
      rating: 5,
      service: 'Trade Show Graphics',
    },
  ];

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          {/* Google Rating Badge */}
          <div className="inline-flex items-center space-x-2 bg-white border border-gray-200 rounded-full px-5 py-2 mb-6">
            <i className="ri-google-fill text-orange-500 text-lg"></i>
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
              ))}
            </div>
            <span className="text-gray-700 text-sm font-semibold">5.0 · Google Verified</span>
          </div>
          <span className="text-teal-600 text-sm font-semibold tracking-widest uppercase mb-3 block">
            Client Reviews
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What Arlington Businesses{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-orange-500">
              Say About Us
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Real results for real businesses throughout Arlington, Grand Prairie, Fort Worth, and
            the DFW Metroplex.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-8 border border-gray-100 hover:border-teal-200 hover:shadow-lg transition-all"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-base"></i>
                  ))}
                </div>
                <span className="text-xs font-semibold text-teal-600 bg-teal-50 border border-teal-100 px-3 py-1 rounded-full">
                  {testimonial.service}
                </span>
              </div>
              <p className="text-gray-700 text-base leading-relaxed mb-6 italic">
                &ldquo;{testimonial.text}&rdquo;
              </p>
              <div className="flex items-center">
                <div className="w-11 h-11 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center text-white font-bold text-base mr-4 flex-shrink-0">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 text-sm">{testimonial.name}</h4>
                  <p className="text-xs text-gray-500">{testimonial.company}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA near testimonials */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center bg-gray-900 rounded-3xl py-12 px-8"
        >
          <p className="text-gray-400 text-sm mb-2">Join hundreds of satisfied Arlington businesses</p>
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-6">
            Your business is next.{' '}
            <span className="text-teal-400">Let&apos;s talk signage.</span>
          </h3>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => {
                const el = document.getElementById('get-quote') || document.getElementById('quote-form');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-3.5 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold rounded-full hover:from-orange-600 hover:to-orange-700 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Request a Free Quote
            </button>
            <a
              href="https://g.co/kgs/1jxvQT5"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer text-sm"
            >
              <i className="ri-google-fill text-orange-400"></i>
              <span>Leave us a Google review</span>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
